import { render, staticRenderFns } from "./receipt-class-component.vue?vue&type=template&id=6cc26fd7&scoped=true&"
import script from "./receipt-class-component.vue?vue&type=script&lang=js&"
export * from "./receipt-class-component.vue?vue&type=script&lang=js&"
import style0 from "./receipt-class-component.vue?vue&type=style&index=0&id=6cc26fd7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc26fd7",
  null
  
)

export default component.exports